export const RESPONSIVE_BREAKPOINTS = {
  tablet: 768,
  table: 992,
  desktop: 1440,
} as const;

export const minWidthQuery = (width: number): string =>
  `(min-width: ${width}px)`;
